function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 22,
  fill: "#66BD0E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52 23.5359C50.7624 22.8214 49.2376 22.8214 48 23.5359L28 35.0829C26.7624 35.7974 26 37.1179 26 38.547V61.641C26 63.0701 26.7624 64.3906 28 65.1051L48 76.6521C49.2376 77.3667 50.7624 77.3667 52 76.6521L72 65.1051C73.2376 64.3906 74 63.0701 74 61.641V38.547C74 37.1179 73.2376 35.7974 72 35.0829L52 23.5359ZM32.3799 38.4119C31.6723 37.9812 30.7495 38.2056 30.3187 38.9133C29.888 39.6209 30.1124 40.5438 30.8201 40.9745L48.5 51.7362V70.8932C48.5 71.7216 49.1716 72.3932 50 72.3932C50.8284 72.3932 51.5 71.7216 51.5 70.8932V51.7362L69.1799 40.9745C69.8876 40.5438 70.112 39.6209 69.6813 38.9133C69.2506 38.2056 68.3277 37.9812 67.6201 38.4119L50 49.1372L32.3799 38.4119Z",
  fill: "white"
});

function SvgScaffolding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaffolding);
export default __webpack_public_path__ + "static/media/scaffolding.51006e81.svg";
export { ForwardRef as ReactComponent };